<template>
  <b-list-group-item class="border-success">
    <b-row>
      <b-col>
        <a href="#" @click="goToSentenza()">
          <p class="font-weight-bold text-success" style="font-size: larger">{{ sentenza.titolo }}</p>
        </a>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="2" class="m-2 text-center">
        <b-button variant="outline-danger" @click="goToSentenza()">
          <img :src="base_url + 'cercasentenze/thumbnail/' + sentenza.idNodo"/>
          <!--<br/><br/><font-awesome-icon icon="file-pdf" />-->
          <br/>Testo integrale
        </b-button>
      </b-col>
      <b-col class="text-justify">
        <div v-html="sentenza.contenuto"></div>
      </b-col>
      <b-col sm="2"></b-col>
    </b-row>
    <b-row>
      <b-col sm="12" class="text-center">
        <b-button v-b-toggle="'sentenza-extra-info-'+sentenza.idAtto" variant="outline-dark">
          <font-awesome-icon icon="info-circle" /> Altre info
        </b-button>
      </b-col>
      <b-col sm="12" class="text-center m-2" style="font-size: smaller">
        <b-collapse :id="'sentenza-extra-info-'+sentenza.idAtto">
          <b-row>
            <b-col md="6" lg="3" class="font-weight-bold"><font-awesome-icon icon="book" /> SEDE:</b-col>
            <b-col md="6" lg="3">{{sentenza.sede}}</b-col>
            <b-col md="6" lg="3" class="font-weight-bold"><font-awesome-icon icon="book" /> SEZIONE:</b-col>
            <b-col md="6" lg="3">{{sentenza.sezione}}</b-col>
          </b-row>
          <b-row>
              <b-col md="6" lg="3" class="font-weight-bold"><font-awesome-icon icon="hashtag" /> NUMERO PROVVEDIMENTO:</b-col>
              <b-col md="6" lg="3">{{sentenza.numProvvedimento}}</b-col>
              <b-col md="6" lg="3" class="font-weight-bold"><font-awesome-icon icon="calendar-day" /> ANNO PROVVEDIMENTO:</b-col>
              <b-col md="6" lg="3">{{sentenza.annoProvvedimento}}</b-col>
          </b-row>
          <b-row>
              <b-col md="6" lg="3" class="font-weight-bold"><font-awesome-icon icon="hashtag" /> NUMERO RICORSO:</b-col>
              <b-col md="6" lg="3">{{sentenza.numRicorso}}</b-col>
          </b-row>
        </b-collapse>
      </b-col>
    </b-row>
  </b-list-group-item>
</template>

<script>
import { type } from 'jquery';
import service from '../../services/service.js';

let getScrollYWrapper = function() {
  return window.scrollY;
}

export default {
  data () {
    return {
      base_url: service.getBaseUrl()
    }
  },
  props: {
    sentenza: {
      idNodo: String,
      titolo: String,
      contenuto: String,
      sede: String,
      sezione: String,
      numRicorso: String,
      annoProvvedimento: String,
      numProvvedimento: String
    },
    filters: Object,
    index: Number
  },
  methods: {
    goToSentenza() {
      this.$router.push({
        name: 'Sentenza',
        params: {
          ...this.sentenza,
          type: 'amministrativa',
          filters: this.filters,
          index: this.index,
          scrollY: getScrollYWrapper()
        }
      });
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Search/ResultAmministrative.vue